<template>
  <div id="footer" class="">
    <div id="footer-box " class="container-fuild footer-content-box">
      <div class="row footer-box-container">
        <div class="col-xs-14 col-sm-14 col-md-8 ">
          <!-- <img class="subtitle-img2 mb-30" src="@/assets/img/home/news2-title1.png" alt=""> -->
          <img class="subtitle-img2 col-md-6 mb-30 " :src="webSiteInfo.logoUrl">
          <div class="col-xs-12 col-sm-6 col-mdj-6 mt-20">
            <div>电话：{{ webSiteInfo.phone }}　 </div>
            <div>地址：{{ webSiteInfo.address }}　</div>
            <div>邮编：{{ webSiteInfo.postalCode }}</div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-4 col-mdj-4">
          <div class="footer-right-box">
            <a :href="webSiteInfo.zgykdWeb" target="_blank" class="footer-right-item">
              <img class=" mb-10" src="@/assets/img/footer/icon3.png" alt="">
              <div>中国医科大学
                <div>官网</div>
              </div>
            </a>
            <el-popover placement="top-start" title="" trigger="hover">
              <div>
                <img style="width: 100px;height: 100px;" :src="webSiteInfo.zgykdMiniWechat" alt="">
              </div>
              <div slot="reference">
                <div class="footer-right-item">
                  <img class=" mb-10" src="@/assets/img/footer/icon6.png" alt="">
                  <div>中国医科大学
                    <div>北京校友会小程序</div>
                  </div>
                </div>
              </div>
            </el-popover>
            <el-popover placement="top-start" title="" trigger="hover">
              <div>
                <img style="width: 100px;height: 100px;" :src="webSiteInfo.zgykdgzh" alt="">
              </div>
              <div slot="reference">
                <div class="footer-right-item">
                  <img class=" mb-10" src="@/assets/img/footer/icon1.png" alt="">
                  <div>中国医科大学
                    <div>
                      北京校友会公众号
                    </div>
                  </div>
                </div>
              </div>
            </el-popover>

            <el-popover placement="top-start" title="" trigger="hover">
              <!-- <div> -->
              <img style="width: 100px;height: 100px;" :src="webSiteInfo.zgykdVideo" alt="">
              <!-- </div> -->
              <div slot="reference">
                <div class="footer-right-item">
                  <img class=" mb-10" src="@/assets/img/footer/icon2.png" alt="">
                  <div>中国医科大学
                    <div>北京校友会视频号</div>
                  </div>
                </div>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
    <div class="foorer-label-box">
      <div class="col-xs-14 col-sm-14 col-md-10" v-html="webSiteInfo.copyright"></div>
      <div class=" col-sm-2 col-mdj-2">
        <div class="flex 0">
          <img class="mr-10" src="@/assets/img/footer/icon4.png" alt="">
          <img class="" src="@/assets/img/footer/icon5.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../api/api'; // 这里替换成实际的模块文件名

export default {
  name: "Footer",
  data() {
    return {
      webSiteInfo: null
    };
  },
  mounted() {
    this.getData()
  },
  methods: {

    getData() {
      api.getWebSiteInfo({ id: 38960498268485 }).then((res) => {
        // console.log(res, 'webSiteInfo');
        this.webSiteInfo = res.result;
      }).catch((error) => {
        console.error(error);
      });
    },
  },
};
</script>
<style>
.el-popover {
  min-width: 100px !important;
}
</style>
<style lang="scss" scoped>
// 
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  /* background: #474747; */
  background: url("../assets/img/footer-bg.png") 0 0 no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
  position: relative;
}

#footer-box {
  transition: all ease 0.6s;
  box-sizing: border-box;
  padding: 50px 100px;
  box-sizing: border-box;

}

.footer-content-box {
  padding: 50px 80px;
  text-align: left;
  // font-size: 20px;
  padding-bottom: 100px;

}

.foorer-label-box {
  background: rgba(0, 0, 0, 0.26);
  padding: 10px 80px !important;
  // padding-bottom: 40px;
  box-sizing: border-box;
  vertical-align: middle;
  line-height: 50px;
  text-align: left;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  img{
    width: 28px ;
    height: 33px;
  }
}

.footer-right-box {
  display: flex;
  align-items: flex-start;
  justify-content: center;

  .footer-right-item {
    min-width: 100px;
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 12px;

    img {
      width: 50px;
      height: 50px;
    }
  }

  a {
    color: #fff;
    text-decoration: none;
  }
}

.subtitle-img {
  height: 81px;
  margin: 0 auto;
  // margin-top: 40px;
  margin-bottom: 40px;
}

.subtitle-img2 {
  // height: 70px;
  // margin-top: 30px;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}


// 
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }

  .subtitle-img2 {
    height: 50px;
    margin: 0 auto;
    // margin-bottom: 20px;
  }

  .footer-content-box {
    padding: 50px 20px;
    text-align: center;
    padding-bottom: 160px;
  }

  .footer-right-box {
    margin-top: 20px;
  }

  .foorer-label-box {
    padding: 20px 0px !important;
    font-size: 12px;
    text-align: center;
    line-height: 15px;
  }

  .flex {
    margin: 0 auto;
    margin-top: 10px;

  }

  .footer-right-item {
    min-width: 80px !important;
    font-size: 11px !important;
    margin-right: 5px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue